export default __webpack_public_path__ + "static/media/previous_arrow.1c195504.svg";